import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography, useMediaQuery } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useTheme } from '@emotion/react'
import { PostRequest } from '../../../../redux/actions/PostRequest' 

const StudentDetailsComp = (props) => {
    // console.log(props)
    props.data.studentOrTeacher = 'student'
    const image = useSelector((state)=>state.Api.imageServer)
    // //console.log(`${image}${props.data.Picture}`)
    const style = useTheme().palette.Components.teacherreoprt;
    const url = useSelector((state)=>state.Api);
    const dispatch = useDispatch();
    const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;

    const [open, setOpen] = useState(false);
    const [webSrn, setWebSrn] = useState(localStorage.getItem('WebSrn'));
    const [modal, setModal] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  

    const func = async(getparam) => {
        setOpen(true);
        // handleClickOpen(getparam)
    }
    
    const handleClickOpen = async(getparam) => {
        const payload = {
            Approved: props.data.approved == '1' ? 0 : 1,
            RollNum: props.data.RollNum,
        }
        await dispatch(PostRequest(url.studentActivitionUpdateActiviation, userToken , payload))
        props.updatefunc()
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const updateinformation = () => {
        setModal(true);
    }
    const modalClose = () => {
        setModal(false);
    }
  return (
    <>
  



       
        <Grid container>
            <Grid item lg={12}>
                <Box p={3}>
                    <Grid container>
                        <Grid item lg={5} md={6} sm={6} xs={6}>
                            <Box display='flex' flexDirection='column' alignItems='center' justifyContent='flex-start' height='100%'>
                                <Avatar
                                src={`${image}${props.data.Picture}`}
                                sx={style.image}
                                />
                            </Box>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Grid container>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant='p'>
                                        Roll Number: <b>{props.data.RollNum}</b>
                                    </Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant='p'>
                                        Name: <b>{props.data.Name}  {props.data.Name_P}</b>
                                    </Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant='p'>
                                        FName: <b>{props.data.FName_P}</b>
                                    </Typography>
                                </Grid>
                                
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant='p'>
                                        Class: <b>{props.data.Class}</b>
                                    </Typography>
                                </Grid>
                                {
                                    props.data.Orphan == 1 ? (
                                        <Grid item lg={12} md={12} sm={12} xs={12} style={{backgroundColor:'#ffe5e5'}}>
                                            <Typography variant='p'>
                                                Orphan : <b>یتیم</b>
                                            </Typography>
                                        </Grid>
                                    ) : null
                                }
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant='p'>
                                        Phone Number: <b>{props.data.TellNo1} , {props.data.TellNo2}</b>
                                    </Typography>
                                </Grid>  
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant='p'>
                                        Transport: <b>{props?.data?.transport}</b>
                                    </Typography>
                                </Grid> 


                                
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant='p'>
                                        Date Of Brith: <b>{props.data.DOB}</b>
                                    </Typography>
                                </Grid>
                               
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant='p'>
                                        Address: <b>{props.data.Address} ,  {props.data.Address_P}</b>
                                    </Typography>
                                </Grid>
                                 
                            </Grid>
                        </Grid>
                    </Grid>

                </Box>
            </Grid>
        </Grid>
    </>
  )
}

StudentDetailsComp.propTypes = {}

export default StudentDetailsComp